import { getTradedPositions, getPortfolioWorkingEquity } from "./index"
import { chain, capitalize } from "lodash"
import { createSelector } from "reselect"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getExcelValue } from "helpers/csv"

const TRADE_TYPES_ORDER = {
  buy: 1,
  sell: 2,
  short: 3,
  cover: 4,
}

const HEADERS = [
  "Trade Type",
  "Identifier",
  "MIC",
  "Country",
  "Asset Class",
  "Currency",
  "Industry",
  "Original Position Size",
  "Rebalanced Position Size",
  "Position $ Change",
  "Original Equity %",
  "Rebalanced Equity %",
  "Equity % Change",
]

const getDate = (state, props) => props.on

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getDate],
  (portfolioName, viewType, date) => `${portfolioName} Experiment Trades ${capitalize(viewType.substr(0, 3))} ${date}`,
)

export const getCsvRows = createSelector(
  [getTradedPositions, getPortfolioWorkingEquity],
  (trades, workingEquity) => ([
    HEADERS,
    ...chain(trades)
      .sortBy([({ tradeType }) => TRADE_TYPES_ORDER[tradeType], "ticker"])
      .map(({ tradeType, ticker, mic, country, assetClass, classification, currency, securityPercentEquity, tradePercentDelta, experimentSize }) => ([
        tradeType,
        ticker,
        mic,
        country,
        assetClass,
        currency,
        classification,
        getExcelValue(securityPercentEquity * workingEquity),
        getExcelValue(experimentSize),
        getExcelValue(experimentSize - (securityPercentEquity * workingEquity)),
        getExcelValue(securityPercentEquity, { percent: true }),
        getExcelValue((experimentSize / workingEquity), { percent: true }),
        getExcelValue(tradePercentDelta, { percent: true }),
      ]))
      .value(),
  ]),
)
